import { ISpsEnvironment } from '@interfaces/sps-environment';

export const environment: ISpsEnvironment = {
  production: true,
  key: 'PROD_LIVE',
  host: 'https://www.spsglobal.com',
  apiHost: 'https://cms.spsglobal.com',
  eloquaApiUrl: 'https://www.spsglobal.com/external/eloqua',
  sentryEnabled: true,
  emailUser: 'formsglobal@spsglobal.com',
  emailPass: 'b`9Dur%na@25',
  eventFormRecipients:
    'monti.ruiz.ext@spsglobal.com,miguel.mederos.ext@spsglobal.com,mhairi.doull@spsglobal.com,dan.robb@spsglobal.com',
  fallbackFormRecipientsEN:
    'monti.ruiz.ext@spsglobal.com,dan.robb@spsglobal.com,miguel.mederos.ext@spsglobal.com,anja.kempa@spsglobal.com',
  fallbackFormRecipientsDE: 'monti.ruiz.ext@spsglobal.com,miguel.mederos.ext@spsglobal.com,anja.kempa@spsglobal.com',
};
